import PlatformSection from "../../components/marketing/PlatformSection";

const HowItWorksPage = () => {
  return (
    <div className="assist">
      <PlatformSection />
    </div>
  );
};

export default HowItWorksPage;